module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-22-d41558b13e3b299bf08555c1ea850476.jpg";